<div
  class="spot-modal dynamic-content-modal--wrapper loading-indicator--location"
  data-indicator-name="modal"
></div>
